import {
  ACCOUNTING_SERVICES_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP,
  ADVERTISING_SERVICES_INDUSTRY_GROUP,
  AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  AGENCIES_BROKERAGES_INDUSTRY_GROUP,
  AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP,
  ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP,
  AMUSEMENT_PARKS_INDUSTRY_GROUP,
  ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  ANIMAL_SLAUGHTERING_INDUSTRY_GROUP,
  APPAREL_ACCESSORIES_INDUSTRY_GROUP,
  APPAREL_KNITTING_MILLS_INDUSTRY_GROUP,
  APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  AQUACULTURE_INDUSTRY_GROUP,
  ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP,
  ARCHITECTURAL_SERVICES_INDUSTRY_GROUP,
  ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP,
  AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP,
  AUTO_DEALERS_INDUSTRY_GROUP,
  AUTOMOTIVE_LEASING_INDUSTRY_GROUP,
  AUTOMOTIVE_PARTS_INDUSTRY_GROUP,
  AUTOMOTIVE_REPAIR_INDUSTRY_GROUP,
  BAKERIES_MANUFACTURING_INDUSTRY_GROUP,
  BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP,
  BEER_WINE_WHOLESALERS_INDUSTRY_GROUP,
  BEVERAGE_MANUFACTURING_INDUSTRY_GROUP,
  BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP,
  BOOK_RETAILERS_INDUSTRY_GROUP,
  BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP,
  BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP,
  BUSINESS_SCHOOLS_INDUSTRY_GROUP,
  BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP,
  CATTLE_RANCHING_FARMING_INDUSTRY_GROUP,
  CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP,
  CHARTER_BUS_INDUSTRY_GROUP,
  CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP,
  CHILD_CARE_SERVICES_INDUSTRY_GROUP,
  CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  CLOTHING_RETAILERS_INDUSTRY_GROUP,
  COAL_MINING_INDUSTRY_GROUP,
  COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP,
  COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP,
  COMMERCIAL_MACHINERY_INDUSTRY_GROUP,
  COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP,
  COMMODITY_CONTRACTS_INDUSTRY_GROUP,
  COMMODITY_EXCHANGES_INDUSTRY_GROUP,
  COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP,
  CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP,
  CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP,
  COURIER_DELIVERY_INDUSTRY_GROUP,
  CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  CUT_AND_SEW_APPAREL_INDUSTRY_GROUP,
  CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP,
  DAIRY_MANUFACTURING_INDUSTRY_GROUP,
  DEATH_CARE_SERVICES_INDUSTRY_GROUP,
  DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP,
  DENTISTS_INDUSTRY_GROUP,
  DEPARTMENT_STORE_INDUSTRY_GROUP,
  DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  DESIGN_SERVICES_INDUSTRY_GROUP,
  DRINKING_PLACES_INDUSTRY_GROUP,
  DRUGS_WHOLESALERS_INDUSTRY_GROUP,
  EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP,
  ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRONICS_REPAIR_INDUSTRY_GROUP,
  ELECTRONICS_RETAILERS_INDUSTRY_GROUP,
  ELEMENTARY_SCHOOLS_INDUSTRY_GROUP,
  EMPLOYMENTS_SERVICES_INDUSTRY_GROUP,
  ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  FABRIC_MILLS_INDUSTRY_GROUP,
  FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP,
  FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  FIBER_YARN_MILLS_INDUSTRY_GROUP,
  FISHING_INDUSTRY_GROUP,
  FLORISTS_INDUSTRY_GROUP,
  FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP,
  FOREST_NURSERIES_INDUSTRY_GROUP,
  FORGING_AND_STAMPING_INDUSTRY_GROUP,
  FOUNDATION_CONTRACTOR_INDUSTRY_GROUP,
  FOUNDRIES_INDUSTRY_GROUP,
  FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP,
  FRUIT_AND_TREE_NUT_INDUSTRY_GROUP,
  FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP,
  FUEL_DEALERS_INDUSTRY_GROUP,
  FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP,
  FURNITURE_RETAILERS_INDUSTRY_GROUP,
  GAMBLING_INDUSTRIES_INDUSTRY_GROUP,
  GASOLINE_STATIONS_INDUSTRY_GROUP,
  GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  GENERAL_MEDICAL_INDUSTRY_GROUP,
  GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP,
  GLASS_MANUFACTURING_INDUSTRY_GROUP,
  GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP,
  GRANTMAKING_INDUSTRY_GROUP,
  GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP,
  GROCERY_RETAILERS_INDUSTRY_GROUP,
  GROCERY_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_MANUFACTURING_INDUSTRY_GROUP,
  HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP,
  HOD_AND_PIG_FARMING_INDUSTRY_GROUP,
  HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP,
  HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP,
  HUNTING_AND_TRAPPING_INDUSTRY_GROUP,
  INDEPENDENT_ARTISTS_INDUSTRY_GROUP,
  INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP,
  INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  INSURANCE_CARRIER_INDUSTRY_GROUP,
  INSURANCE_FUNDS_INDUSTRY_GROUP,
  INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP,
  INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP,
  IRON_AND_STEEL_MILLS_INDUSTRY_GROUP,
  JEWELRY_RETAILERS_INDUSTRY_GROUP,
  JUNIOR_COLLEGES_INDUSTRY_GROUP,
  LAND_SUBDIVISION_INDUSTRY_GROUP,
  LAUNDRY_SERVICES_INDUSTRY_GROUP,
  LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP,
  LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP,
  LEGAL_SERVICES_INDUSTRY_GROUP,
  LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP,
  LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP,
  LOCAL_DELIVERY_INDUSTRY_GROUP,
  LOGGING_INDUSTRY_GROUP,
  LUMBER_WHOLESALERS_INDUSTRY_GROUP,
  MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP,
  MACHINERY_WHOLESALERS_INDUSTRY_GROUP,
  MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP,
  MEDIA_STREAMING_INDUSTRY_GROUP,
  MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  MEDICAL_LABS_INDUSTRY_GROUP,
  METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP,
  METAL_ORE_MINING_INDUSTRY_GROUP,
  METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MOTION_PICTURE_INDUSTRY_GROUP,
  MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP,
  MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP,
  NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP,
  NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP,
  NEWSPAPER_INDUSTRY_GROUP,
  NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP,
  NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP,
  NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  NURSING_CARE_FACILITIES_INDUSTRY_GROUP,
  OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP,
  OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP,
  OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP,
  OILSEED_AND_GRAIN_INDUSTRY_GROUP,
  OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP,
  OTHER_AMUSEMENT_INDUSTRY_GROUP,
  OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP,
  OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_CROP_FARMING_INDUSTRY_GROUP,
  OTHER_EATING_PLACES_INDUSTRY_GROUP,
  OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP,
  OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FUNDS_FUNDS_INDUSTRY_GROUP,
  OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP,
  OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP,
  OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MOTOR_DEALERS_INDUSTRY_GROUP,
  OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP,
  OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_RELIEF_SERVICES_INDUSTRY_GROUP,
  OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP,
  OTHER_SCHOOLS_INDUSTRY_GROUP,
  OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP,
  OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP,
  OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP,
  OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  OTHER_TEXTILE_MILLS_INDUSTRY_GROUP,
  OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_WOOD_PRODUCT_INDUSTRY_GROUP,
  OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP,
  PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP,
  PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP,
  PERSONAL_CARE_SERVICES_INDUSTRY_GROUP,
  PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP,
  PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP,
  PETROLEUM_WHOLESALERS_INDUSTRY_GROUP,
  PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP,
  PHYSICIANS_INDUSTRY_GROUP,
  PLASTIC_MANUFACTURING_INDUSTRY_GROUP,
  POULTRY_AND_EGG_INDUSTRY_GROUP,
  PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP,
  PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP,
  PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP,
  PULP_PAPER_MILLS_INDUSTRY_GROUP,
  RADIO_AND_TELEVISION_INDUSTRY_GROUP,
  RAILROAD_MANUFACTURING_INDUSTRY_GROUP,
  RECREATIONAL_CAMPS_INDUSTRY_GROUP,
  RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP,
  REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP,
  RESERVATION_SERVICES_INDUSTRY_GROUP,
  RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP,
  RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  RETIREMENT_COMMUNITIES_INDUSTRY_GROUP,
  RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP,
  SCENIC_LAND_INDUSTRY_GROUP,
  SCENIC_OTHER_INDUSTRY_GROUP,
  SCENIC_WATER_INDUSTRY_GROUP,
  SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SCHOOL_TRANSPORTATION_INDUSTRY_GROUP,
  SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP,
  SEAFOOD_PREPARATION_INDUSTRY_GROUP,
  SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP,
  SERVICES_TO_BUILDINGS_INDUSTRY_GROUP,
  SHEEP_AND_GOAT_INDUSTRY_GROUP,
  SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP,
  SHOE_RETAILERS_INDUSTRY_GROUP,
  SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP,
  SOCIAL_ADVOCACY_INDUSTRY_GROUP,
  SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP,
  SOFTWARE_PUBLISHERS_INDUSTRY_GROUP,
  SOUND_INDUSTRY_GROUP,
  SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP,
  SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP,
  SPECIALTY_HOSPITALS__INDUSTRY_GROUP,
  SPECTATOR_SPORTS_INDUSTRY_GROUP,
  SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP,
  SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP,
  STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP,
  SUGAR_MANUFACTURING_INDUSTRY_GROUP,
  SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP,
  SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  TAXI_SERVICE_INDUSTRY_GROUP,
  TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP,
  TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP,
  TEXTILE_MILLS_INDUSTRY_GROUP,
  TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP,
  TOBACCO_MANUFACTURING_INDUSTRY_GROUP,
  TRADE_SCHOOLS_INDUSTRY_GROUP,
  TRAVELER_ACCOMMODATION_INDUSTRY_GROUP,
  URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP,
  USED_MERCHANDISE_INDUSTRY_GROUP,
  UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP,
  VEGETABLE_AND_MELON_INDUSTRY_GROUP,
  VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP,
  VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP,
  VENEER_PLYWOOD_INDUSTRY_GROUP,
  VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP,
  VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP,
  WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP,
  WASTE_COLLECTION_INDUSTRY_GROUP,
  WASTE_DISPOSAL_INDUSTRY_GROUP,
  WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  WORKERS_CAMPS_INDUSTRY_GROUP,
} from './industryGroupOptions';
import { MANAGEMENT_OF_COMPANIES_SECTOR } from './industrySectorOptions';
import {
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
} from './industrySubSectorOptions';

export const INDUSTRY_OPTIONS = {
  [OILSEED_AND_GRAIN_INDUSTRY_GROUP]: [
    { value: '11111', label: 'Soybean Farming' },
    { value: '11112', label: 'Oilseed (except Soybean) Farming' },
    { value: '11113', label: 'Dry Pea and Bean Farming' },
    { value: '11114', label: 'Wheat Farming' },
    { value: '11115', label: 'Corn Farming' },
    { value: '11116', label: 'Rice Farming' },
    { value: '111191', label: 'Oilseed and Grain Combination Farming' },
    { value: '111199', label: 'All Other Grain Farming' },
  ],
  [VEGETABLE_AND_MELON_INDUSTRY_GROUP]: [
    { value: '111211', label: 'Potato Farming' },
    { value: '111219', label: 'Other Vegetable (except Potato) and Melon Farming ' },
  ],
  [FRUIT_AND_TREE_NUT_INDUSTRY_GROUP]: [
    { value: '11131', label: 'Orange Groves' },
    { value: '11132', label: 'Citrus (except Orange) Groves' },
    { value: '111331', label: 'Apple Orchards' },
    { value: '111332', label: 'Grape Vineyards' },
    { value: '111333', label: 'Strawberry Farming' },
    { value: '111334', label: 'Berry (except Strawberry) Farming' },
    { value: '111335', label: 'Tree Nut Farming' },
    { value: '111336', label: 'Fruit and Tree Nut Combination Farming' },
    { value: '111339', label: 'Other Noncitrus Fruit Farming' },
  ],
  [GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP]: [
    { value: '111411', label: 'Mushroom Production' },
    { value: '111419', label: 'Other Food Crops Grown Under Cover' },
    { value: '111421', label: 'Nursery and Tree Production' },
    { value: '111422', label: 'Floriculture Production' },
  ],
  [OTHER_CROP_FARMING_INDUSTRY_GROUP]: [
    { value: '11191', label: 'Tobacco Farming' },
    { value: '11192', label: 'Cotton Farming' },
    { value: '11193', label: 'Sugarcane Farming' },
    { value: '11194', label: 'Hay Farming' },
    { value: '111991', label: 'Sugar Beet Farming' },
    { value: '111992', label: 'Peanut Farming' },
    { value: '111998', label: 'All Other Miscellaneous Crop Farming' },
  ],
  [CATTLE_RANCHING_FARMING_INDUSTRY_GROUP]: [
    { value: '112111', label: 'Beef Cattle Ranching and Farming' },
    { value: '112112', label: 'Cattle Feedlots' },
    { value: '11212', label: 'Dairy Cattle and Milk Production' },
    { value: '11213', label: 'Dual-Purpose Cattle Ranching and Farming' },
  ],
  [HOD_AND_PIG_FARMING_INDUSTRY_GROUP]: [],
  [POULTRY_AND_EGG_INDUSTRY_GROUP]: [
    { value: '11231', label: 'Chicken Egg Production' },
    { value: '11232', label: 'Broilers and Other Meat Type Chicken Production' },
    { value: '11233', label: 'Turkey Production' },
    { value: '11233', label: 'Poultry Hatcheries' },
    { value: '11239', label: 'Other Poultry Production' },
  ],
  [SHEEP_AND_GOAT_INDUSTRY_GROUP]: [
    { value: '11241', label: 'Sheep Farming' },
    { value: '11242', label: 'Goat Farming' },
  ],
  [AQUACULTURE_INDUSTRY_GROUP]: [
    { value: '112511', label: 'Finfish Farming and Fish Hatcheries' },
    { value: '112512', label: 'Shellfish Farming' },
    { value: '112519', label: 'Other Aquaculture' },
  ],
  [OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP]: [
    { value: '11291', label: 'Apiculture' },
    { value: '11292', label: 'Horses and Other Equine Production' },
    { value: '11293', label: 'Fur-Bearing Animal and Rabbit Production' },
    { value: '11299', label: 'All Other Animal Production' },
  ],
  [TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP]: [],
  [FOREST_NURSERIES_INDUSTRY_GROUP]: [],
  [LOGGING_INDUSTRY_GROUP]: [],
  [FISHING_INDUSTRY_GROUP]: [
    { value: '114111', label: 'Finfish Fishing' },
    { value: '114112', label: 'Shellfish Fishing' },
    { value: '114119', label: 'Other Marine Fishing' },
  ],
  [HUNTING_AND_TRAPPING_INDUSTRY_GROUP]: [],
  [SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP]: [
    { value: '115111', label: 'Cotton Ginning' },
    { value: '115112', label: 'Soil Preparation, Planting, and Cultivating' },
    { value: '115113', label: 'Crop Harvesting, Primarily by Machine' },
    { value: '115114', label: 'Postharvest Crop Activities (except Cotton Ginning)' },
    { value: '115115', label: 'Farm Labor Contractors and Crew Leaders' },
    { value: '115116', label: 'Farm Management Services' },
  ],
  [OIL_GAS_EXTRACTION_SUB_SECTOR]: [
    { value: '21112', label: 'Crude Petroleum Extraction' },
    { value: '21113', label: 'Natural Gas Extraction' },
  ],
  [COAL_MINING_INDUSTRY_GROUP]: [
    { value: '212114', label: 'Surface Coal Mining' },
    { value: '212115', label: 'Underground Coal Mining' },
  ],
  [METAL_ORE_MINING_INDUSTRY_GROUP]: [
    { value: '21221', label: 'Iron Ore Mining' },
    { value: '21222', label: 'Gold Ore and Silver Ore Mining' },
    { value: '21223', label: 'Copper, Nickel, Lead, and Zinc Mining' },
    { value: '21229', label: 'Other Metal Ore Mining' },
  ],
  [NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP]: [
    { value: '212311', label: 'Dimension Stone Mining and Quarrying' },
    { value: '212312', label: 'Crushed and Broken Limestone Mining and Quarrying' },
    { value: '212313', label: 'Crushed and Broken Granite Mining and Quarrying' },
    { value: '212319', label: 'Other Crushed and Broken Stone Mining and Quarrying' },
    { value: '212321', label: 'Construction Sand and Gravel Mining' },
    { value: '212322', label: 'Industrial Sand Mining' },
    { value: '212323', label: 'Kaolin, Clay, and Ceramic and Refractory Minerals Mining' },
    { value: '21239', label: 'Other Nonmetallic Mineral Mining and Quarrying' },
  ],
  [MINING_SUPPORT_ACTIVITIES_SUB_SECTOR]: [
    { value: '213111', label: 'Drilling Oil and Gas Wells' },
    { value: '213112', label: 'Support Activities for Oil and Gas Operations' },
    { value: '213113', label: 'Support Activities for Coal Mining' },
    { value: '213114', label: 'Support Activities for Metal Mining' },
    { value: '213115', label: 'Support Activities for Nonmetallic Minerals (except Fuels) Mining ' },
  ],
  [ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP]: [
    { value: '221111', label: 'Hydroelectric Power Generation' },
    { value: '221112', label: 'Fossil Fuel Electric Power Generation' },
    { value: '221113', label: 'Nuclear Electric Power Generation' },
    { value: '221114', label: 'Solar Electric Power Generation' },
    { value: '221115', label: 'Wind Electric Power Generation' },
    { value: '221116', label: 'Geothermal Electric Power Generation' },
    { value: '221117', label: 'Biomass Electric Power Generation' },
    { value: '221118', label: 'Other Electric Power Generation' },
    { value: '221121', label: 'Electric Bulk Power Transmission and Control' },
    { value: '221122', label: 'Electric Power Distribution' },
  ],
  [NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP]: [
    { value: '22131', label: 'Water Supply and Irrigation Systems' },
    { value: '22132', label: 'Sewage Treatment Facilities' },
    { value: '22133', label: 'Steam and Air-Conditioning Supply' },
  ],
  [RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP]: [
    { value: '236115', label: 'New Single-Family Housing Construction (except For-Sale Builders)' },
    { value: '236116', label: 'New Multifamily Housing Construction (except For-Sale Builders)' },
    { value: '236117', label: 'New Housing For-Sale Builders' },
    { value: '236118', label: 'Residential Remodelers' },
  ],
  [NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP]: [
    { value: '23621', label: 'Industrial Building Construction' },
    { value: '23622', label: 'Commercial and Institutional Building Construction' },
  ],
  [UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP]: [
    { value: '23711', label: 'Water and Sewer Line and Related Structures Construction' },
    { value: '23712', label: 'Oil and Gas Pipeline and Related Structures Construction' },
    { value: '23713', label: 'Power and Communication Line and Related Structures Construction' },
  ],
  [LAND_SUBDIVISION_INDUSTRY_GROUP]: [],
  [HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP]: [],
  [OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP]: [],
  [FOUNDATION_CONTRACTOR_INDUSTRY_GROUP]: [
    { value: '23811', label: 'Poured Concrete Foundation and Structure Contractors' },
    { value: '23812', label: 'Structural Steel and Precast Concrete Contractors' },
    { value: '23813', label: 'Framing Contractors' },
    { value: '23814', label: 'Masonry Contractors' },
    { value: '23815', label: 'Glass and Glazing Contractors' },
    { value: '23816', label: 'Roofing Contractors' },
    { value: '23817', label: 'Siding Contractors ' },
    { value: '23819', label: 'Other Foundation, Structure, and Building Exterior Contractors' },
  ],
  [BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP]: [
    { value: '23821', label: 'Electrical Contractors and Other Wiring Installation Contractors' },
    { value: '23822', label: 'Plumbing, Heating, and Air-Conditioning Contractors' },
    { value: '23829', label: 'Other Building Equipment Contractors' },
  ],
  [BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP]: [
    { value: '23831', label: 'Drywall and Insulation Contractors' },
    { value: '23832', label: 'Painting and Wall Covering Contractors' },
    { value: '23833', label: 'Flooring Contractors' },
    { value: '23834', label: 'Tile and Terrazzo Contractors' },
    { value: '23835', label: 'Finish Carpentry Contractors' },
    { value: '23839', label: 'Other Building Finishing Contractors' },
  ],
  [OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP]: [
    { value: '23891', label: 'Site Preparation Contractors' },
    { value: '23899', label: 'All Other Specialty Trade Contractors' },
  ],
  [ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311111', label: 'Dog and Cat Food Manufacturing' },
    { value: '311119', label: 'Other Animal Food Manufacturing' },
  ],
  [GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP]: [
    { value: '311211', label: 'Flour Milling' },
    { value: '311212', label: 'Rice Milling' },
    { value: '311213', label: 'Malt Manufacturing' },
    { value: '311221', label: 'Wet Corn Milling and Starch Manufacturing' },
    { value: '311224', label: 'Soybean and Other Oilseed Processing' },
    { value: '311224', label: 'Fats and Oils Refining and Blending' },
    { value: '31123', label: 'Breakfast Cereal Manufacturing' },
  ],
  [SUGAR_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311313', label: 'Beet Sugar Manufacturing' },
    { value: '311314', label: 'Cane Sugar Manufacturing' },
    { value: '31134', label: 'Nonchocolate Confectionery Manufacturing' },
    { value: '31135', label: 'Chocolate and Confectionery Manufacturing' },
  ],
  [FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311411', label: 'Frozen Fruit, Juice, and Vegetable Manufacturing' },
    { value: '311412', label: 'Frozen Specialty Food Manufacturing' },
    { value: '311421', label: 'Fruit and Vegetable Canning' },
    { value: '311422', label: 'Specialty Canning' },
    { value: '311423', label: 'Dried and Dehydrated Food Manufacturing' },
  ],
  [DAIRY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311511', label: 'Fluid Milk Manufacturing' },
    { value: '311512', label: 'Creamery Butter Manufacturing' },
    { value: '311513', label: 'Cheese Manufacturing' },
    { value: '311514', label: 'Dry, Condensed, and Evaporated Dairy Product Manufacturing' },
    { value: '31152', label: 'Ice Cream and Frozen Dessert Manufacturing' },
  ],
  [ANIMAL_SLAUGHTERING_INDUSTRY_GROUP]: [
    { value: '311611', label: 'Animal (except Poultry) Slaughtering' },
    { value: '311612', label: 'Meat Processed from Carcasses' },
    { value: '311613', label: 'Rendering and Meat Byproduct Processing' },
    { value: '311615', label: 'Poultry Processing' },
  ],
  [SEAFOOD_PREPARATION_INDUSTRY_GROUP]: [],
  [BAKERIES_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311811', label: 'Retail Bakeries' },
    { value: '311812', label: 'Commercial Bakeries' },
    { value: '311813', label: 'Frozen Cakes, Pies, and Other Pastries Manufacturing' },
    { value: '311821', label: 'Cookie and Cracker Manufacturing' },
    { value: '311824', label: 'Dry Pasta, Dough, and Flour Mixes Manufacturing from Purchased Flour' },
    { value: '31183', label: 'Tortilla Manufacturing' },
  ],
  [OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311911', label: 'Roasted Nuts and Peanut Butter Manufacturing' },
    { value: '311919', label: 'Other Snack Food Manufacturing' },
    { value: '31192', label: 'Coffee and Tea Manufacturing' },
    { value: '31193', label: 'Flavoring Syrup and Concentrate Manufacturing' },
    { value: '311941', label: 'Mayonnaise, Dressing, and Other Prepared Sauce Manufacturing' },
    { value: '311942', label: 'Spice and Extract Manufacturing' },
    { value: '31199', label: 'All Other Food Manufacturing' },
  ],
  [BEVERAGE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '312111', label: 'Soft Drink Manufacturing' },
    { value: '312112', label: 'Bottled Water Manufacturing' },
    { value: '312113', label: 'Ice Manufacturing' },
    { value: '31212', label: 'Breweries' },
    { value: '31213', label: 'Wineries' },
    { value: '31214', label: 'Distilleries' },
  ],
  [TOBACCO_MANUFACTURING_INDUSTRY_GROUP]: [],
  [FIBER_YARN_MILLS_INDUSTRY_GROUP]: [],
  [FABRIC_MILLS_INDUSTRY_GROUP]: [
    { value: '31321', label: 'Broadwoven Fabric Mills' },
    { value: '31322', label: 'Narrow Fabric Mills and Schiffli Machine Embroidery' },
    { value: '31323', label: 'Nonwoven Fabric Mills' },
    { value: '31324', label: 'Knit Fabric Mills' },
  ],
  [TEXTILE_MILLS_INDUSTRY_GROUP]: [
    { value: '31331', label: 'Textile and Fabric Finishing Mills' },
    { value: '31332', label: 'Fabric Coating Mills' },
  ],
  [TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP]: [
    { value: '31411', label: 'Carpet and Rug Mills' },
    { value: '31412', label: 'Curtain and Linen Mills' },
  ],
  [OTHER_TEXTILE_MILLS_INDUSTRY_GROUP]: [
    { value: '31491', label: 'Textile Bag and Canvas Mills' },
    { value: '314994', label: 'Rope, Cordage, Twine, Tire Cord, and Tire Fabric Mills' },
    { value: '314999', label: 'All Other Miscellaneous Textile Product Mills' },
  ],
  [APPAREL_KNITTING_MILLS_INDUSTRY_GROUP]: [],
  [CUT_AND_SEW_APPAREL_INDUSTRY_GROUP]: [
    { value: '31521', label: 'Cut and Sew Apparel Contractors' },
    { value: '31525', label: 'Cut and Sew Apparel Manufacturing (except Contractors)' },
  ],
  [APPAREL_ACCESSORIES_INDUSTRY_GROUP]: [],
  [LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP]: [],
  [FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP]: [],
  [OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP]: [
    { value: '321113', label: 'Sawmills' },
    { value: '321114', label: 'Wood Preservation' },
  ],
  [VENEER_PLYWOOD_INDUSTRY_GROUP]: [
    { value: '321211', label: 'Hardwood Veneer and Plywood Manufacturing' },
    { value: '321212', label: 'Softwood Veneer and Plywood Manufacturing' },
    { value: '321215', label: 'Engineered Wood Member Manufacturing' },
    { value: '321219', label: 'Reconstituted Wood Product Manufacturing' },
  ],
  [OTHER_WOOD_PRODUCT_INDUSTRY_GROUP]: [
    { value: '321911', label: 'Wood Window and Door Manufacturing' },
    { value: '321912', label: 'Cut Stock, Resawing Lumber, and Planing' },
    { value: '321918', label: 'Other Millwork (including Flooring)' },
    { value: '32192', label: 'Wood Container and Pallet Manufacturing' },
    { value: '321991', label: 'Manufactured Home (Mobile Home) Manufacturing' },
    { value: '321992', label: 'Prefabricated Wood Building Manufacturing' },
    { value: '321999', label: 'All Other Miscellaneous Wood Product Manufacturing' },
  ],
  [PULP_PAPER_MILLS_INDUSTRY_GROUP]: [
    { value: '32211', label: 'Pulp Mills' },
    { value: '32212', label: 'Paper Mills' },
    { value: '32213', label: 'Paperboard Mills' },
  ],
  [CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32221', label: 'Paperboard Container Manufacturing' },
    { value: '32222', label: 'Paper Bag and Coated and Treated Paper Manufacturing' },
    { value: '32223', label: 'Stationery Product Manufacturing' },
    { value: '322291', label: 'Sanitary Paper Product Manufacturing' },
    { value: '322299', label: 'All Other Converted Paper Product Manufacturing' },
  ],
  [BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32511', label: 'Petrochemical Manufacturing' },
    { value: '32512', label: 'Industrial Gas Manufacturing' },
    { value: '32513', label: 'Synthetic Dye and Pigment Manufacturing' },
    { value: '32518', label: 'Other Basic Inorganic Chemical Manufacturing' },
    { value: '325193', label: 'Ethyl Alcohol Manufacturing' },
    { value: '325194', label: 'Cyclic Crude, Intermediate, and Gum and Wood Chemical Manufacturing' },
    { value: '325199', label: 'All Other Basic Organic Chemical Manufacturing' },
  ],
  [RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325211', label: 'Plastics Material and Resin Manufacturing' },
    { value: '325212', label: 'Synthetic Rubber Manufacturing' },
    { value: '32522', label: 'Artificial and Synthetic Fibers and Filaments Manufacturing' },
  ],
  [PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325311', label: 'Nitrogenous Fertilizer Manufacturing' },
    { value: '325312', label: 'Phosphatic Fertilizer Manufacturing' },
    { value: '325314', label: 'Fertilizer (Mixing Only) Manufacturing' },
    { value: '325315', label: 'Compost Manufacturing' },
    { value: '32532', label: 'Pesticide and Other Agricultural Chemical Manufacturing' },
  ],
  [PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325411', label: 'Medicinal and Botanical Manufacturing' },
    { value: '325412', label: 'Pharmaceutical Preparation Manufacturing' },
    { value: '325413', label: 'In-Vitro Diagnostic Substance Manufacturing' },
    { value: '325414', label: 'Biological Product (except Diagnostic) Manufacturing' },
  ],
  [PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32551', label: 'Paint and Coating Manufacturing' },
    { value: '32552', label: 'Adhesive Manufacturing' },
  ],
  [SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325611', label: 'Soap and Other Detergent Manufacturing' },
    { value: '325612', label: 'Polish and Other Sanitation Good Manufacturing' },
    { value: '325613', label: 'Surface Active Agent Manufacturing' },
    { value: '32562', label: 'Toilet Preparation Manufacturing' },
  ],
  [OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32591', label: 'Printing Ink Manufacturing' },
    { value: '32592', label: 'Explosives Manufacturing' },
    { value: '325991', label: 'Custom Compounding of Purchased Resins' },
    { value: '325992', label: 'Photographic Film, Paper, Plate, Chemical, and Copy Toner Manufacturing' },
    { value: '325998', label: 'All Other Miscellaneous Chemical Product and Preparation Manufacturing' },
  ],
  [PLASTIC_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '326111', label: 'Plastics Bag and Pouch Manufacturing' },
    { value: '326112', label: 'Plastics Packaging Film and Sheet (including Laminated) Manufacturing' },
    { value: '326113', label: 'Unlaminated Plastics Film and Sheet (except Packaging) Manufacturing' },
    { value: '326121', label: 'Unlaminated Plastics Profile Shape Manufacturing' },
    { value: '326122', label: 'Plastics Pipe and Pipe Fitting Manufacturing' },
    { value: '32613', label: 'Laminated Plastics Plate, Sheet (except Packaging), and Shape Manufacturing' },
    { value: '32614', label: 'Polystyrene Foam Product Manufacturing' },
    { value: '32615', label: 'Urethane and Other Foam Product (except Polystyrene) Manufacturing' },
    { value: '32616', label: 'Plastics Bottle Manufacturing' },
    { value: '326191', label: 'Plastics Plumbing Fixture Manufacturing' },
    { value: '326199', label: 'All Other Plastics Product Manufacturing' },
  ],
  [RUBBER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '326211', label: 'Tire Manufacturing (except Retreading)' },
    { value: '326212', label: 'Tire Retreading' },
    { value: '32622', label: 'Rubber and Plastics Hoses and Belting Manufacturing' },
    { value: '326291', label: 'Rubber Product Manufacturing for Mechanical Use' },
    { value: '326299', label: 'All Other Rubber Product Manufacturing' },
  ],
  [CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32711', label: 'Pottery, Ceramics, and Plumbing Fixture Manufacturing' },
    { value: '32712', label: 'Clay Building Material and Refractories Manufacturing' },
  ],
  [GLASS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '327211', label: 'Flat Glass Manufacturing' },
    { value: '327212', label: 'Other Pressed and Blown Glass and Glassware Manufacturing' },
    { value: '327213', label: 'Glass Container Manufacturing' },
    { value: '327215', label: 'Glass Product Manufacturing Made of Purchased Glass' },
  ],
  [CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32731', label: 'Cement Manufacturing' },
    { value: '32732', label: 'Ready-Mix Concrete Manufacturing' },
    { value: '327331', label: 'Concrete Block and Brick Manufacturing' },
    { value: '327332', label: 'Concrete Pipe Manufacturing' },
    { value: '32739', label: 'Other Concrete Product Manufacturing' },
  ],
  [LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32741', label: 'Lime Manufacturing' },
    { value: '32742', label: 'Gypsum Product Manufacturing' },
  ],
  [OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32791', label: 'Abrasive Product Manufacturing' },
    { value: '327991', label: 'Cut Stone and Stone Product Manufacturing' },
    { value: '327992', label: 'Ground or Treated Mineral and Earth Manufacturing' },
    { value: '327993', label: 'Mineral Wool Manufacturing' },
    { value: '327999', label: 'All Other Miscellaneous Nonmetallic Mineral Product Manufacturing' },
  ],
  [IRON_AND_STEEL_MILLS_INDUSTRY_GROUP]: [],
  [STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33121', label: 'Iron and Steel Pipe and Tube Manufacturing from Purchased Steel' },
    { value: '331221', label: 'Rolled Steel Shape Manufacturing' },
    { value: '331222', label: 'Steel Wire Drawing' },
  ],
  [ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP]: [
    { value: '331313', label: 'Alumina Refining and Primary Aluminum Production' },
    { value: '331314', label: 'Secondary Smelting and Alloying of Aluminum' },
    { value: '331315', label: 'Aluminum Sheet, Plate, and Foil Manufacturing' },
    { value: '331318', label: 'Other Aluminum Rolling, Drawing, and Extruding' },
  ],
  [NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP]: [
    { value: '33141', label: 'Nonferrous Metal (except Aluminum) Smelting and Refining' },
    { value: '33142', label: 'Copper Rolling, Drawing, Extruding, and Alloying' },
    { value: '331491', label: 'Nonferrous Metal (except Copper and Aluminum) Rolling, Drawing, and Extruding' },
    {
      value: '331492',
      label: 'Secondary Smelting, Refining, and Alloying of Nonferrous Metal (except Copper and Aluminum)',
    },
  ],
  [FOUNDRIES_INDUSTRY_GROUP]: [
    { value: '331511', label: 'Iron Foundries' },
    { value: '331512', label: 'Steel Investment Foundries' },
    { value: '331513', label: 'Steel Foundries (except Investment)' },
    { value: '331523', label: 'Nonferrous Metal Die-Casting Foundries' },
    { value: '331524', label: 'Aluminum Foundries (except Die-Casting)' },
    { value: '331529', label: 'Other Nonferrous Metal Foundries (except Die-Casting)' },
  ],
  [FORGING_AND_STAMPING_INDUSTRY_GROUP]: [
    { value: '332111', label: 'Iron and Steel Forging' },
    { value: '332112', label: 'Nonferrous Forging' },
    { value: '332114', label: 'Custom Roll Forming' },
    { value: '332117', label: 'Powder Metallurgy Part Manufacturing' },
    { value: '332119', label: 'Metal Crown, Closure, and Other Metal Stamping (except Automotive)' },
  ],
  [CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '332215',
      label: 'Metal Kitchen Cookware, Utensil, Cutlery, and Flatware (except Precious) Manufacturing',
    },
    { value: '332216', label: 'Saw Blade and Handtool Manufacturing' },
  ],
  [ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '332311', label: 'Prefabricated Metal Building and Component Manufacturing' },
    { value: '332312', label: 'Fabricated Structural Metal Manufacturing' },
    { value: '332313', label: 'Plate Work Manufacturing' },
    { value: '332321', label: 'Metal Window and Door Manufacturing' },
    { value: '332322', label: 'Sheet Metal Work Manufacturing' },
    { value: '332323', label: 'Ornamental and Architectural Metal Work Manufacturing' },
  ],
  [BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33241', label: 'Power Boiler and Heat Exchanger Manufacturing' },
    { value: '33242', label: 'Metal Tank (Heavy Gauge) Manufacturing' },
    { value: '332431', label: 'Metal Can Manufacturing' },
    { value: '332439', label: 'Other Metal Container Manufacturing' },
  ],
  [HARDWARE_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '332613', label: 'Spring Manufacturing' },
    { value: '332618', label: 'Other Fabricated Wire Product Manufacturing' },
  ],
  [MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33271', label: 'Machine Shops' },
    { value: '332721', label: 'Precision Turned Product Manufacturing' },
    { value: '332722', label: 'Bolt, Nut, Screw, Rivet, and Washer Manufacturing' },
  ],
  [COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP]: [
    { value: '332811', label: 'Metal Heat Treating' },
    {
      value: '332812',
      label: 'Metal Coating, Engraving (except Jewelry and Silverware), and Allied Services to Manufacturers',
    },
    { value: '332813', label: 'Electroplating, Plating, Polishing, Anodizing, and Coloring' },
  ],
  [OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '332911', label: 'Industrial Valve Manufacturing' },
    { value: '332912', label: 'Fluid Power Valve and Hose Fitting Manufacturing' },
    { value: '332913', label: 'Plumbing Fixture Fitting and Trim Manufacturing' },
    { value: '332919', label: 'Other Metal Valve and Pipe Fitting Manufacturing' },
    { value: '332991', label: 'Ball and Roller Bearing Manufacturing' },
    { value: '332992', label: 'Small Arms Ammunition Manufacturing' },
    { value: '332993', label: 'Ammunition (except Small Arms) Manufacturing' },
    { value: '332994', label: 'Small Arms, Ordnance, and Ordnance Accessories Manufacturing' },
    { value: '332996', label: 'Fabricated Pipe and Pipe Fitting Manufacturing' },
    { value: '332999', label: 'All Other Miscellaneous Fabricated Metal Product Manufacturing' },
  ],
  [AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333111', label: 'Farm Machinery and Equipment Manufacturing' },
    { value: '333112', label: 'Lawn and Garden Tractor and Home Lawn and Garden Equipment Manufacturing' },
    { value: '33312', label: 'Construction Machinery Manufacturing' },
    { value: '333131', label: 'Mining Machinery and Equipment Manufacturing' },
    { value: '333132', label: 'Oil and Gas Field Machinery and Equipment Manufacturing' },
  ],
  [INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333241', label: 'Food Product Machinery Manufacturing' },
    { value: '333242', label: 'Semiconductor Machinery Manufacturing' },
    { value: '333243', label: 'Sawmill, Woodworking, and Paper Machinery Manufacturing' },
    { value: '333248', label: 'All Other Industrial Machinery Manufacturing' },
  ],
  [COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP]: [],
  [VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333413', label: 'Industrial and Commercial Fan and Blower and Air Purification Equipment Manufacturing' },
    { value: '333414', label: 'Heating Equipment (except Warm Air Furnaces) Manufacturing' },
    {
      value: '333415',
      label:
        'Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment Manufacturing',
    },
  ],
  [METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333511', label: 'Industrial Mold Manufacturing' },
    { value: '333514', label: 'Special Die and Tool, Die Set, Jig, and Fixture Manufacturing' },
    { value: '333515', label: 'Cutting Tool and Machine Tool Accessory Manufacturing' },
    { value: '333517', label: 'Machine Tool Manufacturing' },
    { value: '333519', label: 'Rolling Mill and Other Metalworking Machinery Manufacturing' },
  ],
  [ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333611', label: 'Turbine and Turbine Generator Set Units Manufacturing' },
    { value: '333612', label: 'Speed Changer, Industrial High-Speed Drive, and Gear Manufacturing' },
    { value: '333613', label: 'Mechanical Power Transmission Equipment Manufacturing' },
    { value: '333618', label: 'Other Engine Equipment Manufacturing' },
  ],
  [OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33391', label: 'Pump and Compressor Manufacturing' },
    { value: '333912', label: 'Air and Gas Compressor Manufacturing' },
    { value: '333914', label: 'Measuring, Dispensing, and Other Pumping Equipment Manufacturing' },
    { value: '333921', label: 'Elevator and Moving Stairway Manufacturing' },
    { value: '333922', label: 'Conveyor and Conveying Equipment Manufacturing' },
    { value: '333923', label: 'Overhead Traveling Crane, Hoist, and Monorail System Manufacturing' },
    { value: '333924', label: 'Industrial Truck, Tractor, Trailer, and Stacker Machinery Manufacturing' },
    { value: '333991', label: 'Power-Driven Handtool Manufacturing' },
    { value: '333992', label: 'Welding and Soldering Equipment Manufacturing' },
    { value: '333993', label: 'Packaging Machinery Manufacturing' },
    { value: '333994', label: 'Industrial Process Furnace and Oven Manufacturing' },
    { value: '333995', label: 'Fluid Power Cylinder and Actuator Manufacturing' },
    { value: '333996', label: 'Fluid Power Pump and Motor Manufacturing' },
    { value: '333998', label: 'All Other Miscellaneous General Purpose Machinery Manufacturing' },
  ],
  [COMPUTER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '334111', label: 'Electronic Computer Manufacturing' },
    { value: '334112', label: 'Computer Storage Device Manufacturing' },
    { value: '334118', label: 'Computer Terminal and Other Computer Peripheral Equipment Manufacturing' },
  ],
  [COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33421', label: 'Telephone Apparatus Manufacturing' },
    { value: '33422', label: 'Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing' },
    { value: '33429', label: 'Other Communications Equipment Manufacturing' },
  ],
  [AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '334412', label: 'Bare Printed Circuit Board Manufacturing' },
    { value: '334413', label: 'Semiconductor and Related Device Manufacturing' },
    { value: '334416', label: 'Capacitor, Resistor, Coil, Transformer, and Other Inductor Manufacturing' },
    { value: '334417', label: 'Electronic Connector Manufacturing' },
    { value: '334418', label: 'Printed Circuit Assembly (Electronic Assembly) Manufacturing' },
    { value: '334419', label: 'Other Electronic Component Manufacturing' },
  ],
  [NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP]: [
    { value: '334510', label: 'Electromedical and Electrotherapeutic Apparatus Manufacturing' },
    {
      value: '334511',
      label: 'Search, Detection, Navigation, Guidance, Aeronautical, and Nautical System and Instrument Manufacturing ',
    },
    {
      value: '334512',
      label: 'Automatic Environmental Control Manufacturing for Residential, Commercial, and Appliance Use ',
    },
    {
      value: '334513',
      label:
        'Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables',
    },
    { value: '334514', label: 'Totalizing Fluid Meter and Counting Device Manufacturing' },
    { value: '334515', label: 'Instrument Manufacturing for Measuring and Testing Electricity and Electrical Signals' },
    { value: '334516', label: 'Analytical Laboratory Instrument Manufacturing' },
    { value: '334517', label: 'Irradiation Apparatus Manufacturing ' },
    { value: '334519', label: 'Other Measuring and Controlling Device Manufacturing' },
  ],
  [MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP]: [],
  [ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '335131', label: 'Residential Electric Lighting Fixture Manufacturing' },
    { value: '335132', label: 'Commercial, Industrial, and Institutional Electric Lighting Fixture Manufacturing' },
    { value: '335139', label: 'Electric Lamp Bulb and Other Lighting Equipment Manufacturing' },
  ],
  [HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33521', label: 'Small Electrical Appliance Manufacturing' },
    { value: '33522', label: 'Major Household Appliance Manufacturing' },
  ],
  [ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '335311', label: 'Power, Distribution, and Specialty Transformer Manufacturing' },
    { value: '335312', label: 'Motor and Generator Manufacturing' },
    { value: '335313', label: 'Switchgear and Switchboard Apparatus Manufacturing' },
    { value: '335314', label: 'Relay and Industrial Control Manufacturing' },
  ],
  [OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33591', label: 'Battery Manufacturing' },
    { value: '335921', label: 'Fiber Optic Cable Manufacturing' },
    { value: '335929', label: 'Other Communication and Energy Wire Manufacturing' },
    { value: '33593', label: 'Wiring Device Manufacturing' },
    { value: '335991', label: 'Carbon and Graphite Product Manufacturing' },
    { value: '335999', label: 'All Other Miscellaneous Electrical Equipment and Component Manufacturing' },
  ],
  [MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33611', label: 'Automobile and Light Duty Motor Vehicle Manufacturing' },
    { value: '33612', label: 'Heavy Duty Truck Manufacturing' },
  ],
  [VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '336211', label: 'Motor Vehicle Body Manufacturing' },
    { value: '336212', label: 'Truck Trailer Manufacturing' },
    { value: '336213', label: 'Motor Home Manufacturing' },
    { value: '336214', label: 'Travel Trailer and Camper Manufacturing' },
  ],
  [VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33631', label: 'Motor Vehicle Gasoline Engine and Engine Parts Manufacturing' },
    { value: '33632', label: 'Motor Vehicle Electrical and Electronic Equipment Manufacturing' },
    { value: '33633', label: 'Motor Vehicle Steering and Suspension Components (except Spring) Manufacturing' },
    { value: '33634', label: 'Motor Vehicle Brake System Manufacturing' },
    { value: '33635', label: 'Motor Vehicle Transmission and Power Train Parts Manufacturing' },
    { value: '33636', label: 'Motor Vehicle Seating and Interior Trim Manufacturing' },
    { value: '33637', label: 'Motor Vehicle Metal Stamping' },
    { value: '33639', label: 'Other Motor Vehicle Parts Manufacturing' },
  ],
  [AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '336411', label: 'Aircraft Manufacturing' },
    { value: '336412', label: 'Aircraft Engine and Engine Parts Manufacturing' },
    { value: '336413', label: 'Other Aircraft Parts and Auxiliary Equipment Manufacturing' },
    { value: '336414', label: 'Guided Missile and Space Vehicle Manufacturing' },
    {
      value: '336415',
      label: 'Guided Missile and Space Vehicle Propulsion Unit and Propulsion Unit Parts Manufacturing',
    },
    { value: '336419', label: 'Other Guided Missile and Space Vehicle Parts and Auxiliary Equipment Manufacturing' },
  ],
  [RAILROAD_MANUFACTURING_INDUSTRY_GROUP]: [],
  [SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP]: [
    { value: '336611', label: 'Ship Building and Repairing' },
    { value: '336612', label: 'Boat Building' },
  ],
  [OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '336991', label: 'Motorcycle, Bicycle, and Parts Manufacturing' },
    { value: '336992', label: 'Military Armored Vehicle, Tank, and Tank Component Manufacturing' },
    { value: '336999', label: 'All Other Transportation Equipment Manufacturing' },
  ],
  [HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33711', label: 'Wood Kitchen Cabinet and Countertop Manufacturing' },
    { value: '337121', label: 'Upholstered Household Furniture Manufacturing' },
    { value: '337122', label: 'Nonupholstered Wood Household Furniture Manufacturing' },
    { value: '337126', label: 'Household Furniture (except Wood and Upholstered) Manufacturing' },
    { value: '337127', label: 'Institutional Furniture Manufacturing' },
  ],
  [OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '337211', label: 'Wood Office Furniture Manufacturing' },
    { value: '337212', label: 'Custom Architectural Woodwork and Millwork Manufacturing' },
    { value: '337214', label: 'Office Furniture (except Wood) Manufacturing' },
    { value: '337215', label: 'Showcase, Partition, Shelving, and Locker Manufacturing' },
  ],
  [OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33791', label: 'Mattress Manufacturing' },
    { value: '33792', label: 'Blind and Shade Manufacturing' },
  ],
  [MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '339112', label: 'Surgical and Medical Instrument Manufacturing' },
    { value: '339113', label: 'Surgical Appliance and Supplies Manufacturing' },
    { value: '339114', label: 'Dental Equipment and Supplies Manufacturing' },
    { value: '339115', label: 'Ophthalmic Goods Manufacturing' },
    { value: '339116', label: 'Dental Laboratories' },
  ],
  [OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33991', label: 'Jewelry and Silverware Manufacturing' },
    { value: '33992', label: 'Sporting and Athletic Goods Manufacturing' },
    { value: '33993', label: 'Doll, Toy, and Game Manufacturing' },
    { value: '33994', label: 'Office Supplies (except Paper) Manufacturing' },
    { value: '33995', label: 'Sign Manufacturing' },
    { value: '339991', label: 'Gasket, Packing, and Sealing Device Manufacturing' },
    { value: '339992', label: 'Musical Instrument Manufacturing' },
    { value: '339993', label: 'Fastener, Button, Needle, and Pin Manufacturing' },
    { value: '339994', label: 'Broom, Brush, and Mop Manufacturing' },
    { value: '339995', label: 'Burial Casket Manufacturing' },
    { value: '339999', label: 'All Other Miscellaneous Manufacturing' },
  ],
  [PRINTING_MANUFACTURING_SUB_SECTOR]: [
    { value: '323111', label: 'Commercial Printing (except Screen and Books)' },
    { value: '323113', label: 'Commercial Screen Printing' },
    { value: '323117', label: 'Books Printing' },
    { value: '32312', label: 'Support Activities for Printing' },
  ],
  [PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR]: [
    { value: '32411', label: 'Petroleum Refineries' },
    { value: '324121', label: 'Asphalt Paving Mixture and Block Manufacturing' },
    { value: '324122', label: 'Asphalt Shingle and Coating Materials Manufacturing' },
    { value: '324191', label: 'Petroleum Lubricating Oil and Grease Manufacturing' },
    { value: '324199', label: 'All Other Petroleum and Coal Products Manufacturing' },
  ],
  [MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42311', label: 'Automobile and Other Motor Vehicle Merchant Wholesalers' },
    { value: '42312', label: 'Motor Vehicle Supplies and New Parts Merchant Wholesalers ' },
    { value: '42313', label: 'Tire and Tube Merchant Wholesalers ' },
    { value: '42314', label: 'Motor Vehicle Parts (Used) Merchant Wholesalers ' },
  ],
  [FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42321', label: 'Furniture Merchant Wholesalers' },
    { value: '42322', label: 'Home Furnishing Merchant Wholesalers' },
  ],
  [LUMBER_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42331', label: 'Lumber, Plywood, Millwork, and Wood Panel Merchant Wholesalers' },
    { value: '42332', label: 'Brick, Stone, and Related Construction Material Merchant Wholesalers' },
    { value: '42333', label: 'Roofing, Siding, and Insulation Material Merchant Wholesalers' },
    { value: '42339', label: 'Other Construction Material Merchant Wholesalers' },
  ],
  [PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42341', label: 'Photographic Equipment and Supplies Merchant Wholesalers' },
    { value: '42342', label: 'Office Equipment Merchant Wholesalers' },
    { value: '42343', label: 'Computer and Computer Peripheral Equipment and Software Merchant Wholesalers' },
    { value: '42344', label: 'Other Commercial Equipment Merchant Wholesalers' },
    { value: '42345', label: 'Medical, Dental, and Hospital Equipment and Supplies Merchant Wholesalers ' },
    { value: '42346', label: 'Ophthalmic Goods Merchant Wholesalers' },
    { value: '42349', label: 'Other Professional Equipment and Supplies Merchant Wholesalers' },
  ],
  [METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42351', label: 'Metal Service Centers and Other Metal Merchant Wholesalers ' },
    { value: '42352', label: 'Coal and Other Mineral and Ore Merchant Wholesalers' },
  ],
  [HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42361',
      label: 'Electrical Apparatus and Equipment, Wiring Supplies, and Related Equipment Merchant Wholesalers ',
    },
    {
      value: '42362',
      label: 'Household Appliances, Electric Housewares, and Consumer Electronics Merchant Wholesalers ',
    },
    { value: '42369', label: 'Other Electronic Parts and Equipment Merchant Wholesalers' },
  ],
  [HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42371', label: 'Hardware Merchant Wholesalers' },
    { value: '42372', label: 'Plumbing and Heating Equipment and Supplies (Hydronics) Merchant Wholesalers' },
    { value: '42373', label: 'Warm Air Heating and Air-Conditioning Equipment and Supplies Merchant Wholesalers' },
    { value: '42374', label: 'Refrigeration Equipment and Supplies Merchant Wholesalers' },
  ],
  [MACHINERY_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42381',
      label: 'Construction and Mining (except Oil Well) Machinery and Equipment Merchant Wholesalers ',
    },
    { value: '42382', label: 'Farm and Garden Machinery and Equipment Merchant Wholesalers' },
    { value: '42383', label: 'Industrial Machinery and Equipment Merchant Wholesalers' },
    { value: '42384', label: 'Industrial Supplies Merchant Wholesalers' },
    { value: '42385', label: 'Service Establishment Equipment and Supplies Merchant Wholesalers' },
    { value: '42386', label: 'Transportation Equipment and Supplies (except Motor Vehicle) Merchant Wholesalers ' },
  ],
  [MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42391', label: 'Sporting and Recreational Goods and Supplies Merchant Wholesalers' },
    { value: '42392', label: 'Toy and Hobby Goods and Supplies Merchant Wholesalers ' },
    { value: '42393', label: 'Recyclable Material Merchant Wholesalers' },
    { value: '42394', label: 'Jewelry, Watch, Precious Stone, and Precious Metal Merchant Wholesalers' },
    { value: '42399', label: 'Other Miscellaneous Durable Goods Merchant Wholesalers' },
  ],
  [PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42411', label: 'Printing and Writing Paper Merchant Wholesalers' },
    { value: '42412', label: 'Stationery and Office Supplies Merchant Wholesalers' },
    { value: '42413', label: 'Industrial and Personal Service Paper Merchant Wholesalers' },
  ],
  [DRUGS_WHOLESALERS_INDUSTRY_GROUP]: [],
  [APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42431', label: 'Piece Goods, Notions, and Other Dry Goods Merchant Wholesalers' },
    { value: '42434', label: 'Footwear Merchant Wholesalers ' },
    { value: '42435', label: 'Clothing and Clothing Accessories Merchant Wholesalers' },
  ],
  [GROCERY_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42441', label: 'General Line Grocery Merchant Wholesalers' },
    { value: '42442', label: 'Packaged Frozen Food Merchant Wholesalers' },
    { value: '42443', label: 'Dairy Product (except Dried or Canned) Merchant Wholesalers ' },
    { value: '42444', label: 'Poultry and Poultry Product Merchant Wholesalers' },
    { value: '42445', label: 'Confectionery Merchant Wholesalers' },
    { value: '42446', label: 'Fish and Seafood Merchant Wholesalers' },
    { value: '42447', label: 'Meat and Meat Product Merchant Wholesalers' },
    { value: '42448', label: 'Fresh Fruit and Vegetable Merchant Wholesalers' },
    { value: '42449', label: 'Other Grocery and Related Products Merchant Wholesalers' },
  ],
  [FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42451', label: 'Grain and Field Bean Merchant Wholesalers' },
    { value: '42452', label: 'Livestock Merchant Wholesalers' },
    { value: '42459', label: 'Other Farm Product Raw Material Merchant Wholesalers' },
  ],
  [CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42461', label: 'Plastics Materials and Basic Forms and Shapes Merchant Wholesalers' },
    { value: '42469', label: 'Other Chemical and Allied Products Merchant Wholesalers' },
  ],
  [PETROLEUM_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42471', label: 'Petroleum Bulk Stations and Terminals ' },
    {
      value: '42472',
      label: 'Petroleum and Petroleum Products Merchant Wholesalers (except Bulk Stations and Terminals) ',
    },
  ],
  [BEER_WINE_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42481', label: 'Beer and Ale Merchant Wholesalers' },
    { value: '42482', label: 'Wine and Distilled Alcoholic Beverage Merchant Wholesalers' },
  ],
  [MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42491', label: 'Farm Supplies Merchant Wholesalers ' },
    { value: '42492', label: 'Book, Periodical, and Newspaper Merchant Wholesalers ' },
    { value: '42493', label: "Flower, Nursery Stock, and Florists' Supplies Merchant Wholesalers" },
    { value: '42494', label: 'Tobacco Product and Electronic Cigarette Merchant Wholesalers' },
    { value: '42495', label: 'Paint, Varnish, and Supplies Merchant Wholesalers' },
    { value: '42499', label: 'Other Miscellaneous Nondurable Goods Merchant Wholesalers' },
  ],
  [AGENTS_AND_BROKERS_SUB_SECTOR]: [],
  [AUTO_DEALERS_INDUSTRY_GROUP]: [
    { value: '44111', label: 'New Car Dealers' },
    { value: '44112', label: 'Used Car Dealers' },
  ],
  [OTHER_MOTOR_DEALERS_INDUSTRY_GROUP]: [
    { value: '44121', label: 'Recreational Vehicle Dealers ' },
    { value: '441222', label: 'Boat Dealers' },
    { value: '441227', label: 'Motorcycle, ATV, and All Other Motor Vehicle Dealers' },
  ],
  [AUTOMOTIVE_PARTS_INDUSTRY_GROUP]: [
    { value: '44133', label: 'Automotive Parts and Accessories Retailers' },
    { value: '44134', label: 'Tire Dealers' },
  ],
  [BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP]: [
    { value: '44411', label: 'Home Centers' },
    { value: '44412', label: 'Paint and Wallpaper Retailers' },
    { value: '44414', label: 'Hardware Retailers' },
    { value: '44418', label: 'Other Building Material Dealers' },
  ],
  [LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP]: [
    { value: '44423', label: 'Outdoor Power Equipment Retailers' },
    { value: '44424', label: 'Nursery, Garden Center, and Farm Supply Retailers' },
  ],
  [GROCERY_RETAILERS_INDUSTRY_GROUP]: [
    { value: '44511', label: 'Supermarkets and Other Grocery Retailers (except Convenience Retailers)' },
    { value: '445131', label: 'Convenience Retailers' },
    { value: '445132', label: 'Vending Machine Operators' },
  ],
  [SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP]: [
    { value: '44523', label: 'Fruit and Vegetable Retailers' },
    { value: '44524', label: 'Meat Retailers' },
    { value: '44525', label: 'Fish and Seafood Retailers' },
    { value: '445291', label: 'Baked Goods Retailers' },
    { value: '445292', label: 'Confectionery and Nut Retailers' },
    { value: '445298', label: 'All Other Specialty Food Retailers' },
  ],
  [BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP]: [],
  [FURNITURE_RETAILERS_INDUSTRY_GROUP]: [
    { value: '44911', label: 'Furniture Retailers' },
    { value: '449121', label: 'Floor Covering Retailers' },
    { value: '449122', label: 'Window Treatment Retailers' },
    { value: '449129', label: 'All Other Home Furnishings Retailers' },
  ],
  [ELECTRONICS_RETAILERS_INDUSTRY_GROUP]: [],
  [DEPARTMENT_STORE_INDUSTRY_GROUP]: [],
  [WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP]: [
    { value: '455211', label: 'Warehouse Clubs and Supercenters ' },
    { value: '455219', label: 'All Other General Merchandise Retailers' },
  ],
  [HEALTH_RETAILERS_SUB_SECTOR]: [
    { value: '45611', label: 'Pharmacies and Drug Retailers ' },
    { value: '45612', label: 'Cosmetics, Beauty Supplies, and Perfume Retailers' },
    { value: '45613', label: 'Optical Goods Retailers' },
    { value: '456191', label: 'Food (Health) Supplement Retailers' },
    { value: '456199', label: 'All Other Health and Personal Care Retailers' },
  ],
  [GASOLINE_STATIONS_INDUSTRY_GROUP]: [
    { value: '45711', label: 'Gasoline Stations with Convenience Stores' },
    { value: '45712', label: 'Other Gasoline Stations' },
  ],
  [FUEL_DEALERS_INDUSTRY_GROUP]: [],
  [CLOTHING_RETAILERS_INDUSTRY_GROUP]: [],
  [SHOE_RETAILERS_INDUSTRY_GROUP]: [],
  [JEWELRY_RETAILERS_INDUSTRY_GROUP]: [
    { value: '45831', label: 'Jewelry Retailers ' },
    { value: '45832', label: 'Luggage and Leather Goods Retailers' },
  ],
  [SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP]: [
    { value: '45911', label: 'Sporting Goods Retailers' },
    { value: '45912', label: 'Hobby, Toy, and Game Retailers' },
    { value: '45913', label: 'Sewing, Needlework, and Piece Goods Retailers' },
    { value: '45914', label: 'Musical Instrument and Supplies Retailers' },
  ],
  [BOOK_RETAILERS_INDUSTRY_GROUP]: [],
  [FLORISTS_INDUSTRY_GROUP]: [],
  [OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP]: [
    { value: '45941', label: 'Office Supplies and Stationery Retailers' },
    { value: '45942', label: 'Gift, Novelty, and Souvenir Retailers' },
  ],
  [USED_MERCHANDISE_INDUSTRY_GROUP]: [],
  [OTHER_MISCELLANEOUS_INDUSTRY_GROUP]: [
    { value: '45991', label: 'Pet and Pet Supplies Retailers' },
    { value: '45992', label: 'Art Dealers' },
    { value: '45993', label: 'Manufactured (Mobile) Home Dealers' },
    { value: '45999', label: 'All Other Miscellaneous Retailers' },
    { value: '459991', label: 'Tobacco, Electronic Cigarette, and Other Smoking Supplies Retailers' },
  ],
  [SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '481111', label: 'Scheduled Passenger Air Transportation ' },
    { value: '481112', label: 'Scheduled Freight Air Transportation ' },
  ],
  [NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '481211', label: 'Nonscheduled Chartered Passenger Air Transportation' },
    { value: '481212', label: 'Nonscheduled Chartered Freight Air Transportation' },
    { value: '481219', label: 'Other Nonscheduled Air Transportation' },
  ],
  [DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '483111', label: 'Deep Sea Freight Transportation' },
    { value: '483112', label: 'Deep Sea Passenger Transportation' },
    { value: '483113', label: 'Coastal and Great Lakes Freight Transportation' },
    { value: '483114', label: 'Coastal and Great Lakes Passenger Transportation' },
  ],
  [INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '483211', label: 'Inland Water Freight Transportation' },
    { value: '483212', label: 'Inland Water Passenger Transportation' },
  ],
  [GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP]: [
    { value: '48411', label: 'General Freight Trucking, Local' },
    { value: '484121', label: 'General Freight Trucking, Long-Distance, Truckload' },
    { value: '484122', label: 'General Freight Trucking, Long-Distance, Less Than Truckload' },
  ],
  [SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP]: [
    { value: '48421', label: 'Used Household and Office Goods Moving' },
    { value: '48422', label: 'Specialized Freight (except Used Goods) Trucking, Local' },
    { value: '48423', label: 'Specialized Freight (except Used Goods) Trucking, Long-Distance' },
  ],
  [URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP]: [
    { value: '485111', label: 'Mixed Mode Transit Systems' },
    { value: '485112', label: 'Commuter Rail Systems' },
    { value: '485113', label: 'Bus and Other Motor Vehicle Transit Systems' },
    { value: '485119', label: 'Other Urban Transit Systems' },
  ],
  [INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [TAXI_SERVICE_INDUSTRY_GROUP]: [
    { value: '48531', label: 'Taxi and Ridesharing Services' },
    { value: '48532', label: 'Limousine Service' },
  ],
  [SCHOOL_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [CHARTER_BUS_INDUSTRY_GROUP]: [],
  [OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '485991', label: 'Special Needs Transportation ' },
    { value: '485999', label: 'All Other Transit and Ground Passenger Transportation ' },
  ],
  [CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48691', label: 'Pipeline Transportation of Refined Petroleum Products' },
    { value: '48699', label: 'All Other Pipeline Transportation' },
  ],
  [SCENIC_LAND_INDUSTRY_GROUP]: [],
  [SCENIC_WATER_INDUSTRY_GROUP]: [],
  [SCENIC_OTHER_INDUSTRY_GROUP]: [],
  [SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48811', label: 'Airport Operations' },
    { value: '488111', label: 'Air Traffic Control' },
    { value: '488119', label: 'Other Airport Operations ' },
    { value: '48819', label: 'Other Support Activities for Air Transportation' },
  ],
  [SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP]: [],
  [SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48831', label: 'Port and Harbor Operations' },
    { value: '48832', label: 'Marine Cargo Handling' },
    { value: '48833', label: 'Navigational Services to Shipping' },
    { value: '48839', label: 'Other Support Activities for Water Transportation' },
  ],
  [SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48841', label: 'Motor Vehicle Towing' },
    { value: '48849', label: 'Other Support Activities for Road Transportation' },
  ],
  [FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP]: [],
  [OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '488991', label: 'Packing and Crating' },
    { value: '488999', label: 'All Other Support Activities for Transportation' },
  ],
  [COURIER_DELIVERY_INDUSTRY_GROUP]: [],
  [LOCAL_DELIVERY_INDUSTRY_GROUP]: [],
  [MOTION_PICTURE_INDUSTRY_GROUP]: [
    { value: '51211', label: 'Motion Picture and Video Production' },
    { value: '51212', label: 'Motion Picture and Video Distribution' },
    { value: '51213', label: 'Motion Picture and Video Exhibition' },
    { value: '51219', label: 'Postproduction Services and Other Motion Picture and Video Industries' },
    { value: '512191', label: 'Teleproduction and Other Postproduction Services ' },
    { value: '512199', label: 'Other Motion Picture and Video Industries ' },
  ],
  [SOUND_INDUSTRY_GROUP]: [
    { value: '51223', label: 'Music Publishers' },
    { value: '51224', label: 'Sound Recording Studios' },
    { value: '51225', label: 'Record Production and Distribution' },
    { value: '51229', label: 'Other Sound Recording Industries' },
  ],
  [NEWSPAPER_INDUSTRY_GROUP]: [
    { value: '51311', label: 'Newspaper Publishers' },
    { value: '51312', label: 'Periodical Publishers' },
    { value: '51313', label: 'Book Publishers' },
    { value: '51314', label: 'Directory and Mailing List Publishers' },
    { value: '513191', label: 'Greeting Card Publishers' },
    { value: '513199', label: 'All Other Publishers' },
  ],
  [SOFTWARE_PUBLISHERS_INDUSTRY_GROUP]: [],
  [RADIO_AND_TELEVISION_INDUSTRY_GROUP]: [
    { value: '51611', label: 'Radio Broadcasting Stations' },
    { value: '51612', label: 'Television Broadcasting Stations' },
  ],
  [MEDIA_STREAMING_INDUSTRY_GROUP]: [],
  [WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [
    { value: '517111', label: 'Wired Telecommunications Carriers ' },
    { value: '517112', label: 'Wireless Telecommunications Carriers (except Satellite)' },
    { value: '517121', label: 'Telecommunications Resellers' },
    { value: '517122', label: 'Agents for Wireless Telecommunications Services' },
  ],
  [SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [],
  [OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [],
  [DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP]: [
    { value: '52211', label: 'Commercial Banking' },
    { value: '52213', label: 'Credit Unions' },
    { value: '52218', label: 'Savings Institutions and Other Depository Credit Intermediation' },
  ],
  [NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP]: [
    { value: '52221', label: 'Credit Card Issuing' },
    { value: '52222', label: 'Sales Financing' },
    { value: '522291', label: 'Consumer Lending' },
    { value: '522292', label: 'Real Estate Credit' },
    { value: '522299', label: 'International, Secondary Market, and All Other Nondepository Credit Intermediation' },
  ],
  [ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP]: [
    { value: '52231', label: 'Mortgage and Nonmortgage Loan Brokers ' },
    { value: '52232', label: 'Financial Transactions Processing, Reserve, and Clearinghouse Activities ' },
    { value: '52239', label: 'Other Activities Related to Credit Intermediation' },
  ],
  [COMMODITY_CONTRACTS_INDUSTRY_GROUP]: [
    { value: '52315', label: 'Investment Banking and Securities Intermediation' },
    { value: '52316', label: 'Commodity Contracts Intermediation' },
  ],
  [COMMODITY_EXCHANGES_INDUSTRY_GROUP]: [],
  [OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP]: [
    { value: '52391', label: 'Miscellaneous Intermediation' },
    { value: '52394', label: 'Portfolio Management and Investment Advice' },
    { value: '523991', label: 'Trust, Fiduciary, and Custody Activities' },
    { value: '523999', label: 'Miscellaneous Financial Investment Activities' },
  ],
  [INSURANCE_CARRIER_INDUSTRY_GROUP]: [
    { value: '52411', label: 'Direct Life, Health, and Medical Insurance Carriers' },
    { value: '524126', label: 'Direct Property and Casualty Insurance Carriers ' },
    { value: '524127', label: 'Direct Title Insurance Carriers' },
    { value: '524128', label: 'Other Direct Insurance (except Life, Health, and Medical) Carriers' },
    { value: '52413', label: 'Reinsurance Carriers' },
  ],
  [AGENCIES_BROKERAGES_INDUSTRY_GROUP]: [
    { value: '52421', label: 'Insurance Agencies and Brokerages ' },
    { value: '524291', label: 'Claims Adjusting' },
    {
      value: '524292',
      label: 'Pharmacy Benefit Management and Other Third Party Administration of Insurance and Pension Funds ',
    },
    { value: '524298', label: 'All Other Insurance Related Activities' },
  ],
  [INSURANCE_FUNDS_INDUSTRY_GROUP]: [
    { value: '52511', label: 'Pension Funds' },
    { value: '52512', label: 'Health and Welfare Funds ' },
    { value: '52519', label: 'Other Insurance Funds' },
  ],
  [OTHER_FUNDS_FUNDS_INDUSTRY_GROUP]: [
    { value: '52591', label: 'Open-End Investment Funds' },
    { value: '52592', label: 'Trusts, Estates, and Agency Accounts' },
    { value: '52599', label: 'Other Financial Vehicles' },
  ],
  [LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP]: [
    { value: '53111', label: 'Lessors of Residential Buildings and Dwellings ' },
    { value: '53112', label: 'Lessors of Nonresidential Buildings (except Miniwarehouses)' },
    { value: '53113', label: 'Lessors of Miniwarehouses and Self-Storage Units' },
    { value: '53119', label: 'Lessors of Other Real Estate Property' },
  ],
  [OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP]: [],
  [ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP]: [
    { value: '53131', label: 'Real Estate Property Managers' },
    { value: '53132', label: 'Offices of Real Estate Appraisers' },
    { value: '53139', label: 'Other Activities Related to Real Estate' },
  ],
  [AUTOMOTIVE_LEASING_INDUSTRY_GROUP]: [
    { value: '53211', label: 'Passenger Car Rental and Leasing' },
    { value: '53212', label: 'Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing' },
  ],
  [CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP]: [
    { value: '53221', label: 'Consumer Electronics and Appliances Rental' },
    { value: '532281', label: 'Formal Wear and Costume Rental' },
    { value: '532282', label: 'Video Tape and Disc Rental' },
    { value: '532283', label: 'Home Health Equipment Rental' },
    { value: '532284', label: 'Recreational Goods Rental' },
    { value: '532289', label: 'All Other Consumer Goods Rental ' },
  ],
  [GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP]: [],
  [COMMERCIAL_MACHINERY_INDUSTRY_GROUP]: [
    { value: '532411', label: 'Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing' },
    { value: '532412', label: 'Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing ' },
    { value: '53242', label: 'Office Machinery and Equipment Rental and Leasing' },
    { value: '53249', label: 'Other Commercial and Industrial Machinery and Equipment Rental and Leasing' },
  ],
  [LEGAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54111', label: 'Offices of Lawyers' },
    { value: '54112', label: 'Offices of Notaries' },
    { value: '541191', label: 'Title Abstract and Settlement Offices' },
    { value: '541199', label: 'All Other Legal Services' },
  ],
  [ACCOUNTING_SERVICES_INDUSTRY_GROUP]: [
    { value: '541211', label: 'Offices of Certified Public Accountants' },
    { value: '541213', label: 'Tax Preparation Services' },
    { value: '541214', label: 'Payroll Services' },
    { value: '541219', label: 'Other Accounting Services' },
  ],
  [ARCHITECTURAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54131', label: 'Architectural Services' },
    { value: '54132', label: 'Landscape Architectural Services' },
    { value: '54133', label: 'Engineering Services' },
    { value: '54134', label: 'Drafting Services' },
    { value: '54135', label: 'Building Inspection Services' },
    { value: '54136', label: 'Geophysical Surveying and Mapping Services' },
    { value: '54137', label: 'Surveying and Mapping (except Geophysical) Services' },
    { value: '54138', label: 'Testing Laboratories and Services' },
  ],
  [DESIGN_SERVICES_INDUSTRY_GROUP]: [
    { value: '54141', label: 'Interior Design Services' },
    { value: '54142', label: 'Industrial Design Services' },
    { value: '54143', label: 'Graphic Design Services' },
    { value: '54149', label: 'Other Specialized Design Services' },
  ],
  [COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP]: [
    { value: '541511', label: 'Custom Computer Programming Services' },
    { value: '541512', label: 'Computer Systems Design Services' },
    { value: '541513', label: 'Computer Facilities Management Services ' },
    { value: '541519', label: 'Other Computer Related Services' },
  ],
  [TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP]: [
    { value: '541611', label: 'Administrative Management and General Management Consulting Services' },
    { value: '541612', label: 'Human Resources Consulting Services' },
    { value: '541613', label: 'Marketing Consulting Services' },
    { value: '541614', label: 'Process, Physical Distribution, and Logistics Consulting Services' },
    { value: '541618', label: 'Other Management Consulting Services' },
    { value: '54162', label: 'Environmental Consulting Services' },
    { value: '54169', label: 'Other Scientific and Technical Consulting Services' },
  ],
  [SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP]: [
    { value: '541713', label: 'Research and Development in Nanotechnology' },
    { value: '541714', label: 'Research and Development in Biotechnology (except Nanobiotechnology)' },
    {
      value: '541715',
      label:
        'Research and Development in the Physical, Engineering, and Life Sciences (except Nanotechnology and Biotechnology)',
    },
    { value: '54172', label: 'Research and Development in the Social Sciences and Humanities' },
  ],
  [ADVERTISING_SERVICES_INDUSTRY_GROUP]: [
    { value: '54181', label: 'Advertising Agencies' },
    { value: '54182', label: 'Public Relations Agencies' },
    { value: '54183', label: 'Media Buying Agencies' },
    { value: '54184', label: 'Media Representatives' },
    { value: '54185', label: 'Indoor and Outdoor Display Advertising' },
    { value: '54186', label: 'Direct Mail Advertising' },
    { value: '54187', label: 'Advertising Material Distribution Services' },
    { value: '54189', label: 'Other Services Related to Advertising' },
  ],
  [OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54191', label: 'Marketing Research and Public Opinion Polling' },
    { value: '54192', label: 'Photographic Services' },
    { value: '54193', label: 'Translation and Interpretation Services' },
    { value: '54194', label: 'Veterinary Services' },
    { value: '54199', label: 'All Other Professional, Scientific, and Technical Services' },
  ],
  [OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP]: [],
  [FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP]: [],
  [EMPLOYMENTS_SERVICES_INDUSTRY_GROUP]: [
    { value: '561311', label: 'Employment Placement Agencies' },
    { value: '561312', label: 'Executive Search Services' },
    { value: '56132', label: 'Temporary Help Services' },
    { value: '56133', label: 'Professional Employer Organizations' },
  ],
  [BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP]: [
    { value: '56141', label: 'Document Preparation Services' },
    { value: '56142', label: 'Telephone Call Centers' },
    { value: '56143', label: 'Business Service Centers' },
    { value: '561431', label: 'Private Mail Centers' },
    { value: '561439', label: 'Other Business Service Centers (including Copy Shops)' },
    { value: '56144', label: 'Collection Agencies' },
    { value: '56145', label: 'Credit Bureaus' },
    { value: '561491', label: 'Repossession Services ' },
    { value: '561492', label: 'Court Reporting and Stenotype Services ' },
    { value: '561499', label: 'All Other Business Support Services' },
  ],
  [RESERVATION_SERVICES_INDUSTRY_GROUP]: [
    { value: '56151', label: 'Travel Agencies' },
    { value: '56152', label: 'Tour Operators' },
    { value: '56159', label: 'Other Travel Arrangement and Reservation Services' },
  ],
  [INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP]: [
    { value: '561611', label: 'Investigation and Personal Background Check Services ' },
    { value: '561612', label: 'Security Guards and Patrol Services ' },
    { value: '561613', label: 'Armored Car Services' },
    { value: '56162', label: 'Security Systems Services' },
  ],
  [SERVICES_TO_BUILDINGS_INDUSTRY_GROUP]: [
    { value: '56171', label: 'Exterminating and Pest Control Services' },
    { value: '56172', label: 'Janitorial Services' },
    { value: '56173', label: 'Landscaping Services' },
    { value: '56174', label: 'Carpet and Upholstery Cleaning Services' },
    { value: '56179', label: 'Other Services to Buildings and Dwellings' },
  ],
  [OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP]: [
    { value: '56191', label: 'Packaging and Labeling Services' },
    { value: '56192', label: 'Convention and Trade Show Organizers' },
    { value: '56199', label: 'All Other Support Services' },
  ],
  [WASTE_COLLECTION_INDUSTRY_GROUP]: [
    { value: '562111', label: 'Solid Waste Collection' },
    { value: '562112', label: 'Hazardous Waste Collection' },
    { value: '562119', label: 'Other Waste Collection' },
  ],
  [WASTE_DISPOSAL_INDUSTRY_GROUP]: [
    { value: '562211', label: 'Hazardous Waste Treatment and Disposal ' },
    { value: '562212', label: 'Solid Waste Landfill' },
    { value: '562213', label: 'Solid Waste Combustors and Incinerators' },
    { value: '562219', label: 'Other Nonhazardous Waste Treatment and Disposal' },
  ],
  [REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP]: [
    { value: '56291', label: 'Remediation Services ' },
    { value: '56292', label: 'Materials Recovery Facilities ' },
    { value: '56299', label: 'All Other Waste Management Services ' },
    { value: '562991', label: 'Septic Tank and Related Services ' },
    { value: '562998', label: 'All Other Miscellaneous Waste Management Services' },
  ],
  [ELEMENTARY_SCHOOLS_INDUSTRY_GROUP]: [],
  [JUNIOR_COLLEGES_INDUSTRY_GROUP]: [],
  [PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP]: [],
  [BUSINESS_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '61141', label: 'Business and Secretarial Schools' },
    { value: '61142', label: 'Computer Training' },
    { value: '61143', label: 'Professional and Management Development Training' },
  ],
  [TRADE_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '611511', label: 'Cosmetology and Barber Schools ' },
    { value: '611512', label: 'Flight Training' },
    { value: '611513', label: 'Apprenticeship Training' },
    { value: '611519', label: 'Other Technical and Trade Schools' },
  ],
  [OTHER_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '61161', label: 'Fine Arts Schools' },
    { value: '61162', label: 'Sports and Recreation Instruction' },
    { value: '61163', label: 'Language Schools' },
    { value: '61169', label: 'All Other Schools and Instruction' },
    { value: '611691', label: 'Exam Preparation and Tutoring' },
    { value: '611692', label: 'Automobile Driving Schools' },
    { value: '611699', label: 'All Other Miscellaneous Schools and Instruction ' },
  ],
  [EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP]: [],
  [PHYSICIANS_INDUSTRY_GROUP]: [
    { value: '621111', label: 'Offices of Physicians (except Mental Health Specialists) ' },
    { value: '621112', label: 'Offices of Physicians, Mental Health Specialists' },
  ],
  [DENTISTS_INDUSTRY_GROUP]: [],
  [OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP]: [
    { value: '62131', label: 'Offices of Chiropractors' },
    { value: '62132', label: 'Offices of Optometrists' },
    { value: '62133', label: 'Offices of Mental Health Practitioners (except Physicians)' },
    { value: '62134', label: 'Offices of Physical, Occupational and Speech Therapists, and Audiologists' },
    { value: '621391', label: 'Offices of Podiatrists' },
    { value: '621399', label: 'Offices of All Other Miscellaneous Health Practitioners' },
  ],
  [OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP]: [
    { value: '61141', label: 'Family Planning Centers' },
    { value: '61142', label: 'Outpatient Mental Health and Substance Abuse Centers' },
    { value: '61149', label: 'Other Outpatient Care Centers' },
  ],
  [MEDICAL_LABS_INDUSTRY_GROUP]: [
    { value: '621511', label: 'Medical Laboratories' },
    { value: '621512', label: 'Diagnostic Imaging Centers' },
  ],
  [HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP]: [],
  [OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP]: [
    { value: '62191', label: 'Ambulance Services' },
    { value: '621991', label: 'Blood and Organ Banks' },
    { value: '621999', label: 'All Other Miscellaneous Ambulatory Health Care Services' },
  ],
  [GENERAL_MEDICAL_INDUSTRY_GROUP]: [],
  [SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP]: [],
  [SPECIALTY_HOSPITALS__INDUSTRY_GROUP]: [],
  [NURSING_CARE_FACILITIES_INDUSTRY_GROUP]: [],
  [RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP]: [
    { value: '62321', label: 'Residential Intellectual and Developmental Disability Facilities' },
    { value: '62322', label: 'Residential Mental Health and Substance Abuse Facilities' },
  ],
  [RETIREMENT_COMMUNITIES_INDUSTRY_GROUP]: [
    { value: '623311', label: 'Residential Mental Health and Substance Abuse Facilities' },
    { value: '623312', label: 'Assisted Living Facilities for the Elderly' },
  ],
  [OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP]: [],
  [INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP]: [
    { value: '62411', label: 'Child and Youth Services' },
    { value: '62412', label: 'Services for the Elderly and Persons with Disabilities' },
    { value: '62419', label: 'Other Individual and Family Services' },
  ],
  [OTHER_RELIEF_SERVICES_INDUSTRY_GROUP]: [
    { value: '62421', label: 'Community Food Services' },
    { value: '62422', label: 'Community Housing Services' },
    { value: '62423', label: 'Emergency and Other Relief Services' },
  ],
  [VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP]: [],
  [CHILD_CARE_SERVICES_INDUSTRY_GROUP]: [],
  [PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP]: [
    { value: '71111', label: 'Theater Companies and Dinner Theaters' },
    { value: '71112', label: 'Dance Companies' },
    { value: '71113', label: 'Musical Groups and Artists' },
    { value: '71119', label: 'Other Performing Arts Companies' },
  ],
  [SPECTATOR_SPORTS_INDUSTRY_GROUP]: [
    { value: '711211', label: 'Sports Teams and Clubs' },
    { value: '711212', label: 'Racetracks ' },
    { value: '711219', label: 'Other Spectator Sports' },
  ],
  [PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP]: [
    { value: '71131', label: 'Promoters of Performing Arts, Sports, and Similar Events with Facilities' },
    { value: '71132', label: 'Promoters of Performing Arts, Sports, and Similar Events without Facilities' },
  ],
  [ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP]: [],
  [INDEPENDENT_ARTISTS_INDUSTRY_GROUP]: [],
  [AMUSEMENT_PARKS_INDUSTRY_GROUP]: [
    { value: '71311', label: 'Amusement and Theme Parks' },
    { value: '71312', label: 'Amusement Arcades' },
  ],
  [GAMBLING_INDUSTRIES_INDUSTRY_GROUP]: [
    { value: '71321', label: 'Casinos (except Casino Hotels)' },
    { value: '71329', label: 'Other Gambling Industries' },
  ],
  [OTHER_AMUSEMENT_INDUSTRY_GROUP]: [
    { value: '71391', label: 'Golf Courses and Country Clubs' },
    { value: '71392', label: 'Skiing Facilities' },
    { value: '71393', label: 'Marinas' },
    { value: '71394', label: 'Fitness and Recreational Sports Centers' },
    { value: '71395', label: 'Bowling Centers' },
    { value: '71399', label: 'All Other Amusement and Recreation Industries' },
  ],
  [TRAVELER_ACCOMMODATION_INDUSTRY_GROUP]: [
    { value: '72111', label: 'Hotels (except Casino Hotels) and Motels' },
    { value: '72112', label: 'Casino Hotels' },
    { value: '72119', label: 'Other Traveler Accommodation' },
    { value: '721191', label: 'Bed-and-Breakfast Inns' },
    { value: '721199', label: 'All Other Traveler Accommodation' },
  ],
  [RECREATIONAL_CAMPS_INDUSTRY_GROUP]: [
    { value: '721211', label: 'RV (Recreational Vehicle) Parks and Campgrounds' },
    { value: '721214', label: 'Recreational and Vacation Camps (except Campgrounds)' },
  ],
  [WORKERS_CAMPS_INDUSTRY_GROUP]: [],
  [SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP]: [
    { value: '72231', label: 'Food Service Contractors' },
    { value: '72232', label: 'Caterers' },
    { value: '72233', label: 'Mobile Food Services' },
  ],
  [DRINKING_PLACES_INDUSTRY_GROUP]: [],
  [OTHER_EATING_PLACES_INDUSTRY_GROUP]: [
    { value: '722511', label: 'Full-Service Restaurants' },
    { value: '722513', label: 'Limited-Service Restaurants' },
    { value: '722514', label: 'Cafeterias, Grill Buffets, and Buffets' },
    { value: '722515', label: 'Snack and Nonalcoholic Beverage Bars' },
  ],
  [AUTOMOTIVE_REPAIR_INDUSTRY_GROUP]: [
    { value: '811111', label: 'General Automotive Repair ' },
    { value: '811114', label: 'Specialized Automotive Repair ' },
    { value: '811121', label: 'Automotive Body, Paint, and Interior Repair and Maintenance ' },
    { value: '811122', label: 'Automotive Glass Replacement Shops' },
    { value: '811191', label: 'Automotive Oil Change and Lubrication Shops ' },
    { value: '811192', label: 'Car Washes' },
    { value: '811198', label: 'All Other Automotive Repair and Maintenance' },
  ],
  [ELECTRONICS_REPAIR_INDUSTRY_GROUP]: [],
  [COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP]: [],
  [PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP]: [
    { value: '811411', label: 'Home and Garden Equipment Repair and Maintenance' },
    { value: '811412', label: 'Appliance Repair and Maintenance' },
    { value: '81142', label: 'Reupholstery and Furniture Repair' },
    { value: '81143', label: 'Footwear and Leather Goods Repair' },
    { value: '81149', label: 'Other Personal and Household Goods Repair and Maintenance' },
  ],
  [PERSONAL_CARE_SERVICES_INDUSTRY_GROUP]: [
    { value: '812111', label: 'Barber Shops ' },
    { value: '812112', label: 'Beauty Salons' },
    { value: '812113', label: 'Nail Salons' },
    { value: '81219', label: 'Other Personal Care Services' },
    { value: '812191', label: 'Diet and Weight Reducing Centers' },
  ],
  [DEATH_CARE_SERVICES_INDUSTRY_GROUP]: [
    { value: '81221', label: 'Funeral Homes and Funeral Services' },
    { value: '81222', label: 'Cemeteries and Crematories' },
  ],
  [LAUNDRY_SERVICES_INDUSTRY_GROUP]: [
    { value: '81231', label: 'Coin-Operated Laundries and Drycleaner' },
    { value: '81232', label: 'Drycleaning and Laundry Services (except Coin-Operated)' },
    { value: '812331', label: 'Linen Supply ' },
    { value: '812332', label: 'Industrial Launderers' },
  ],
  [OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '81291', label: 'Pet Care (except Veterinary) Services' },
    { value: '81292', label: 'Photofinishing ' },
    { value: '81293', label: 'Parking Lots and Garages' },
    { value: '81299', label: 'All Other Personal Services ' },
  ],
  [RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP]: [],
  [GRANTMAKING_INDUSTRY_GROUP]: [
    { value: '813211', label: 'Grantmaking Foundations' },
    { value: '813212', label: 'Voluntary Health Organizations' },
    { value: '813219', label: 'Other Grantmaking and Giving Services' },
  ],
  [SOCIAL_ADVOCACY_INDUSTRY_GROUP]: [
    { value: '813311', label: 'Human Rights Organizations ' },
    { value: '813312', label: 'Environment, Conservation and Wildlife Organizations' },
    { value: '813319', label: 'Other Social Advocacy Organizations' },
  ],
  [SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP]: [],
  [BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP]: [
    { value: '81391', label: 'Business Associations ' },
    { value: '81392', label: 'Professional Organizations' },
    { value: '81393', label: 'Labor Unions and Similar Labor Organizations' },
    { value: '81394', label: 'Political Organizations' },
    {
      value: '81399',
      label: 'Other Similar Organizations (except Business, Professional, Labor, and Political Organizations)',
    },
  ],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [
    { value: '551111', label: 'Offices of Bank Holding Companies' },
    { value: '551112', label: 'Offices of Other Holding Companies' },
    { value: '551114', label: 'Corporate, Subsidiary, and Regional Managing Offices' },
  ],
  [RAIL_TRANSPORTATION_SUB_SECTOR]: [
    { value: '482111', label: 'Line-Haul Railroads ' },
    { value: '482112', label: 'Short Line Railroads' },
  ],
  [POSTAL_SERVICE_SUB_SECTOR]: [],
  [WAREHOUSING_AND_STORAGE_SUB_SECTOR]: [
    { value: '49311', label: 'General Warehousing and Storage' },
    { value: '49312', label: 'Refrigerated Warehousing and Storage' },
    { value: '49313', label: 'Farm Product Warehousing and Storage' },
    { value: '49319', label: 'Other Warehousing and Storage' },
  ],
  [COMPUTING_INFRASTRUCTURE_SUB_SECTOR]: [],
  [WEB_SEARCH_PORTALS_SUB_SECTOR]: [
    { value: '51921', label: 'Libraries and Archives' },
    { value: '51929', label: 'Web Search Portals and All Other Information Services' },
  ],
  [MONETARY_BANK_SUB_SECTOR]: [],
  [LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR]: [],
  [MUSEUMS_SUB_SECTOR]: [
    { value: '71211', label: 'Museums' },
    { value: '71212', label: 'Historical Sites' },
    { value: '71213', label: 'Zoos and Botanical Gardens' },
    { value: '71219', label: 'Nature Parks and Other Similar Institutions' },
  ],
  [PRIVATE_HOUSEHOLDS_SUB_SECTOR]: [],
  [EXECUTIVE_LEGISLATIVE_SUB_SECTOR]: [
    { value: '92111', label: 'Executive Offices' },
    { value: '92112', label: 'Legislative Bodies ' },
    { value: '92113', label: 'Public Finance Activities' },
    { value: '92114', label: 'Executive and Legislative Offices, Combined ' },
    { value: '92115', label: 'American Indian and Alaska Native Tribal Governments' },
    { value: '92119', label: 'Other General Government Support ' },
  ],
  [JUSTICE_PUBLIC_ORDER_SUB_SECTOR]: [
    { value: '92211', label: 'Courts' },
    { value: '92212', label: 'Police Protection ' },
    { value: '92213', label: 'Legal Counsel and Prosecution' },
    { value: '92214', label: 'Correctional Institutions ' },
    { value: '92215', label: 'Parole Offices and Probation Offices' },
    { value: '92216', label: 'Fire Protection' },
    { value: '92219', label: 'Other Justice, Public Order, and Safety Activities' },
  ],
  [ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR]: [
    { value: '92311', label: 'Administration of Education Programs' },
    { value: '92312', label: 'Administration of Public Health Programs' },
    {
      value: '92313',
      label:
        "Administration of Human Resource Programs (except Education, Public Health, and Veterans' Affairs Programs)",
    },
    { value: '92314', label: "Administration of Veterans' Affairs" },
  ],
  [ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR]: [
    { value: '92411', label: 'Administration of Air and Water Resource and Solid Waste Management Programs' },
    { value: '92412', label: 'Administration of Conservation Programs ' },
  ],
  [ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR]: [
    { value: '92511', label: 'Administration of Housing Programs' },
    { value: '92512', label: 'Administration of Urban Planning and Community and Rural Development' },
  ],
  [ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR]: [
    { value: '92611', label: 'Administration of General Economic Programs ' },
    { value: '92612', label: 'Regulation and Administration of Transportation Programs' },
    { value: '92613', label: 'Regulation and Administration of Communications, Electric, Gas, and Other Utilities' },
    { value: '92614', label: 'Regulation of Agricultural Marketing and Commodities' },
    { value: '92615', label: 'Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors' },
  ],
  [SPACE_RESEARCH_SUB_SECTOR]: [],
  [NATIONAL_SECURITY_SUB_SECTOR]: [
    { value: '92811', label: 'National Security ' },
    { value: '92812', label: 'International Affairs' },
  ],
};
